export default __webpack_public_path__ + "793eeb6f5eb4387cb2fda8b64a01f119.png";